import InsertNewDataModal from './NewInsertNewDataModal';

export default InsertNewDataModal;